import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import {
  fetchReactionUsers,
  fetchReactionUsersSuccess,
  fetchReactionUsersFailure,
  addCurrentUserToReaction,
  removeCurrentUserFromReaction,
  invalidateReactionUsersList,
} from '../actions/message';

export default handleActions<DamzState['reactionUsers'], any>(
  {
    [`${fetchReactionUsers}`]: (
      state,
      action: ReturnType<typeof fetchReactionUsers>
    ) => ({
      ...state,
      [action.payload.messageId]: {
        ...state[action.payload.messageId],
        [action.payload.emoji_id]: {
          users:
            state[action.payload.messageId]?.[action.payload.emoji_id]?.users ||
            [],
          isLoading: true,
          error: null,
        },
      },
    }),

    [`${fetchReactionUsersSuccess}`]: (
      state,
      action: ReturnType<typeof fetchReactionUsersSuccess>
    ) => ({
      ...state,
      [action.payload.messageId]: {
        ...state[action.payload.messageId],
        [action.payload.emoji_id]: {
          users: action.payload.users,
          isLoading: false,
          error: null,
        },
      },
    }),

    [`${fetchReactionUsersFailure}`]: (
      state,
      action: ReturnType<typeof fetchReactionUsersFailure>
    ) => ({
      ...state,
      [action.payload.messageId]: {
        ...state[action.payload.messageId],
        [action.payload.emoji_id]: {
          users:
            state[action.payload.messageId]?.[action.payload.emoji_id]?.users ||
            [],
          isLoading: false,
          error: action.payload.error,
        },
      },
    }),

    [`${addCurrentUserToReaction}`]: (
      state,
      action: ReturnType<typeof addCurrentUserToReaction>
    ) => {
      const { messageId, emoji_id, currentUser } = action.payload;
      const currentUsers = state[messageId]?.[emoji_id]?.users || [];
      const userExists = currentUsers.some(
        user => user.useridUuid === currentUser.useridUuid
      );

      if (userExists) {
        return state;
      }

      return {
        ...state,
        [messageId]: {
          ...state[messageId],
          [emoji_id]: {
            users: [...currentUsers, currentUser],
            isLoading: false,
            error: null,
          },
        },
      };
    },

    [`${removeCurrentUserFromReaction}`]: (
      state,
      action: ReturnType<typeof removeCurrentUserFromReaction>
    ) => {
      const { messageId, emoji_id, currentUser } = action.payload;
      const currentUsers = state[messageId]?.[emoji_id]?.users || [];
      const filteredUsers = currentUsers.filter(
        user => user.useridUuid !== currentUser.useridUuid
      );

      return {
        ...state,
        [messageId]: {
          ...state[messageId],
          [emoji_id]: {
            users: filteredUsers,
            isLoading: false,
            error: null,
          },
        },
      };
    },
    [`${invalidateReactionUsersList}`]: (
      state,
      action: ReturnType<typeof invalidateReactionUsersList>
    ) => {
      const { messageId } = action.payload;
      return {
        ...state,
        [messageId]: {},
      };
    },
  },
  {}
);
